/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Content_TypeInputs */

const en_field_content_type = /** @type {(inputs: Field_Content_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content`)
};

const es_field_content_type = /** @type {(inputs: Field_Content_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido`)
};

const fr_field_content_type = /** @type {(inputs: Field_Content_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu`)
};

const de_field_content_type = /** @type {(inputs: Field_Content_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalt`)
};

const ja_field_content_type = /** @type {(inputs: Field_Content_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンテンツ内容`)
};

const zh_field_content_type = /** @type {(inputs: Field_Content_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容类型`)
};

const ar_field_content_type = /** @type {(inputs: Field_Content_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المحتوى`)
};

const id_field_content_type = /** @type {(inputs: Field_Content_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten`)
};

const it_field_content_type = /** @type {(inputs: Field_Content_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenuto`)
};

const ru_field_content_type = /** @type {(inputs: Field_Content_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Содержание`)
};

const pt_field_content_type = /** @type {(inputs: Field_Content_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo`)
};

const ko_field_content_type = /** @type {(inputs: Field_Content_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`콘텐츠 유형`)
};

/**
* | output |
* | --- |
* | "Content" |
*
* @param {Field_Content_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_content_type = /** @type {((inputs?: Field_Content_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Content_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_content_type(inputs)
	if (locale === "es") return es_field_content_type(inputs)
	if (locale === "fr") return fr_field_content_type(inputs)
	if (locale === "de") return de_field_content_type(inputs)
	if (locale === "ja") return ja_field_content_type(inputs)
	if (locale === "zh") return zh_field_content_type(inputs)
	if (locale === "ar") return ar_field_content_type(inputs)
	if (locale === "id") return id_field_content_type(inputs)
	if (locale === "it") return it_field_content_type(inputs)
	if (locale === "ru") return ru_field_content_type(inputs)
	if (locale === "pt") return pt_field_content_type(inputs)
	return ko_field_content_type(inputs)
});